module.exports = __webpack_public_path__ + "img/lucia-gyo.2f06e4b0.jpg";